import ApiService from "@/core/services/ApiService";

class EventService {

    public static getList(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events', data)
    }

    public static getDetails(data: any) {
        ApiService.setHeader()
        return ApiService.get('api/events', data)
    }

    public static getSports(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events/sports', data)
    }

    public static getSportCategory(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events/sport-category', data)
    }

    public static getSportModality(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events/sport-modality', data)
    }

    public static getSportConfig(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events/sport-config', data)
    }

    public static getClubs(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events/institutions', data)
    }

    public static getNominal(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events/nominal', data)
    }

    /*MANTENIMIENTO*/
    public static save(data: any) {
        ApiService.setHeader()
        return ApiService.post('api/events/save', data)
    }

    public static edit(id: string) {
        ApiService.setHeader()
        return ApiService.get(`api/events/${id}`, 'edit')
    }

    public static update (id, data) {
        ApiService.setHeader()
        return ApiService.put(`api/events/${id}/update`,data)
    }

    public static delete(id: string) {
        ApiService.setHeader()
        return ApiService.delete(`api/events/${id}`, 'delete')
    }

    /*CONFIGURACIONES*/
    public static getSetting(){
        ApiService.setHeader()
        return ApiService.get('api/events', 'setting')
    }

    /*FORMULARIOS*/
    //Formularios asociados al evento
    public static getForms(id: any){
        ApiService.setHeader()
        return ApiService.get(`api/events/${id}`, 'forms')
    }

    public static getFormList(data: any){
        ApiService.setHeader()
        return ApiService.post('api/forms/list', data)
    }

    /*RESUMENES*/
    public static summary(data: any)
    {
        ApiService.setHeader()
        return ApiService.post('api/events/summary', data)
    }

    public static sumaryTRegister(data: any)
    {
        ApiService.setHeader()
        return ApiService.post('api/events/sumary-tregister', data)
    }

    public static sumaryCheckDoc(data: any)
    {
        ApiService.setHeader()
        return ApiService.post('api/events/sumary-checkdoc', data)
    }

    public static sumaryGender(data: any)
    {
        ApiService.setHeader()
        return ApiService.post('api/events/sumary-gender', data)
    }

    public static sumaryPeriodo(data: any)
    {
        ApiService.setHeader()
        return ApiService.get('api/charts', data)
    }

    public static options(slug: any, data: any)
    {
        ApiService.setHeader()
        return ApiService.post(`api/events/${slug}`, data)
    }


}

export default EventService;